import { PermissionException } from "../customExceptions";
import store from "../store";

export const checkPermissions = async (neededPermissions) => {
  const { currentUser } = store.getState().auth;
  const hasNeededPermissions = neededPermissions.every(
    ({ feature, action }) => {
      const userPermissions = currentUser?.permissions.find(
        (p) => p.feature === feature
      );

      // If the feature is not found in user permissions, return false
      if (!userPermissions) return false;

      // If the action is READ, return true as the existence of the feature implies READ permission
      if (action === "READ") return true;

      const propertyMap = {
        CREATE: "canCreate",
        UPDATE: "canUpdate",
        DELETE: "canDelete",
      };
      return userPermissions[propertyMap[action]];
    }
  );
  return hasNeededPermissions;
};

export const checkPermissionsAndRedirect = async (permissions) => {
  const { isInitialized, isAuthenticated, currentUser } = store.getState().auth;

  // Deep links can run route guards before auth bootstrap settles.
  // Skip permission enforcement until auth state is reliable.
  if (!isInitialized) return;
  if (!isAuthenticated || !currentUser) return;

  // REFACTOR test what is happening when refresh token fails
  if (!(await checkPermissions(permissions))) {
    throw new PermissionException("Unsufficient permissions");
  }
};
